module.exports = __webpack_public_path__ + "static/media/mail.5b814a27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mail.svg
// module id = 62
// module chunks = 0